import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SIZES, COLORS, MQS } from '../app/common/constants/styles';
import Header from '../about/Header';
import { IReduxRootState } from '../app/reduxRootState.interface';
import FooterContainer from '../footer/FooterContainer';
import { TranslationHelpers } from '../i18n/translationHelpers';

const Container = styled.div`
    background-color: ${COLORS.ultralightGrey};
    height: 100%;
    font-family: Rakuten Sans UI Regular, sans-serif;
`;

const Content = styled.div`
    max-width: ${1 * SIZES.appMaxWidth}px;
    margin: 0px auto;
    padding: 0px 20px;

    h2 {
        font-family: Rakuten Sans UI Bold, sans-serif;
        font-size: 43px;
        margin-top: 40px;
    }

    h3 {
        font-family: Rakuten Sans UI Bold, sans-serif;
        font-size: 35px;
        margin-top: 40px;
    }

    p {
        font-size: 18px;
        line-height: 1.57;

        a {
            text-decoration: none;
            color: ${COLORS.rakutenRed};
            font-weight: bold;
        }

        b {
            font-weight: bold;
        }
    }

    ul {
        li {
            line-height: 28px;
            font-size: 18px;
        }
    }

    @media (max-width: ${MQS.mq2Min}) {
        word-break: break-word;
    }
`;

const PointsTermsOfUse = () => {
    const appConfig = useSelector((state: IReduxRootState) => state.app.appConfig);

    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <Container>
            <Header appConfig={appConfig} />
            <Content>
                <h2>{TranslationHelpers.getFormattedMessage('pointsTerms.title')}</h2>
                <p>{TranslationHelpers.getFormattedMessage('pointsTerms.effective.date')}</p>
                <p>{TranslationHelpers.getFormattedMessage('pointsTerms.description.1')}</p>

                <h2>{TranslationHelpers.getFormattedMessage('pointsTerms.heading.1')}</h2>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.1.description.1')}
                </p>

                <h2>{TranslationHelpers.getFormattedMessage('pointsTerms.heading.2')}</h2>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.1')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.2')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.3')}
                </p>
                <ul>
                    <li>
                        {TranslationHelpers.getFormattedMessage(
                            'pointsTerms.heading.2.description.3.listItem.1',
                        )}
                    </li>
                    <li>
                        {TranslationHelpers.getFormattedMessage(
                            'pointsTerms.heading.2.description.3.listItem.2',
                        )}
                    </li>
                </ul>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.4')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.5')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.6')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.7')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.8')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.9')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.10')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.11')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.2.description.12')}
                </p>

                <h2>{TranslationHelpers.getFormattedMessage('pointsTerms.heading.3')}</h2>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.3.description.1')}
                </p>
                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.3.description.2')}
                </p>

                <h2>{TranslationHelpers.getFormattedMessage('pointsTerms.heading.4')}</h2>

                <p>
                    {TranslationHelpers.getFormattedMessage('pointsTerms.heading.4.description.1')}
                </p>
            </Content>
            <FooterContainer />
        </Container>
    );
};

export default PointsTermsOfUse;
